module.exports = __webpack_public_path__ + "static/media/lds-logo_da.4ac45f6d.svg";